/* eslint-disable no-underscore-dangle */
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { get, isEmpty, filter, includes, find, findIndex } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, message, Spin, Radio, Result, Input } from 'antd';
import FeatherIcon from 'feather-icons-react';
import { PageHeader } from '../../components/page-headers/page-headers';
import { Cards } from '../../components/cards/frame/cards-frame';
import { Button } from '../../components/buttons/buttons';
// import { Checkbox } from '../../components/checkbox/checkbox';
import Palette from '../../components/color-palette/palette';
import { Main, ButtonLineWrapper, ButtonsWrapper } from '../styled';
import { fetchCategories, fetchProducts, sendOrder, initializeState } from '../../redux/pos/actionCreator';
import { theme } from '../../config/theme/themeVariables';
import CartList from '../../components/cartList/cartList';
import OrderCard from '../../components/orderCard/orderCard';
import { fetchPrinterConfig } from '../../utility/utility';

const { TextArea } = Input;

const STEPS = {
  SELECT_CATEGORY: 1,
  SELECT_PRODUCT: 2,
  SELECT_OPTIONS: 3,
  ADD_MORE_STEP: 4,
  ORDER_FINISHED: 5,
};

const initialState = {
  categorySelected: null,
  productSelected: null,
  step: 1,
  title: 'Selecciona la categoría',
  showModalPay: false,
  orderCreated: {},
  loadingPay: false,
};

const initialOrder = { products: [], customerName: '', note: '' };
const POS = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { categories, products, loading, createOrderResult = {} } = useSelector(state => state.pos);
  const [state, setState] = useState(initialState);
  const [productOptions, setProductOptions] = useState({});
  const [productOptionsCount, setProductOptionsCount] = useState({});
  const [productToAdd, setProductToAdd] = useState({});
  const [order, setOrder] = useState(initialOrder);
  const [expandedOptions, setExpandedOptions] = useState({});
  const { categorySelected, step, title, productSelected, orderCreated } = state;

  const [ipName, setIpName] = useState('');

  const fetchPrinterConfiguration = async () => {
    const _ipName = await fetchPrinterConfig();
    setIpName(_ipName);
  };

  useEffect(() => {
    console.log('useEffect ipConfig');
    if (!ipName) {
      fetchPrinterConfiguration();
    }
  }, [ipName]);

  const handleOnClickCategory = data => {
    setState({ ...state, step: STEPS.SELECT_PRODUCT, title: 'Selecciona un producto', categorySelected: data });
  };

  const setInitialStateScreen = () => {
    setState(initialState);
    setOrder(initialOrder);
    setProductToAdd({});
    dispatch(initializeState());
  };
  const handleOnClickNewOrder = () => {
    setInitialStateScreen();
  };

  const handleOnClickGoToOrders = () => {
    setInitialStateScreen();
    history.replace('/admin/ordenes');
  };

  const handleOnClickProduct = data => {
    const optionsToSelect = data?.options?.length;
    setState({
      ...state,
      step: optionsToSelect ? STEPS.SELECT_OPTIONS : STEPS.ADD_MORE_STEP,
      title: optionsToSelect ? `Selecciona opciones del producto: ${data.name}` : 'Resumen de la orden',
      productSelected: data,
    });

    setProductToAdd({ ...productToAdd, ...data, finalPrice: data.price });
    if (!optionsToSelect) {
      setOrder({ ...order, products: [...order.products, { ...data, finalPrice: data.price }] });
    }
  };

  const onNoteChange = evt => {
    const note = evt?.target?.value;
    setOrder({
      ...order,
      note,
    });
  };

  const onNameChange = evt => {
    const customerName = evt?.target?.value;
    setOrder({
      ...order,
      customerName,
    });
  };

  const incrementUpdate = (index, quantity) => {
    const data = parseInt(quantity, 10) + 1;
    const allItems = order.products;
    allItems[index].quantity = data;
    setOrder({ ...order, products: allItems });
  };

  const decrementUpdate = (index, quantity) => {
    const data = parseInt(quantity, 10) >= 2 ? parseInt(quantity, 10) - 1 : 1;
    const allItems = order.products;
    allItems[index].quantity = data;
    setOrder({ ...order, products: allItems });
  };

  // USE EFFECTS
  useEffect(() => {
    if (!isEmpty(createOrderResult)) {
      if (!createOrderResult.error) message.success('Orden Creada Exitosamente');

      setState({
        ...state,
        ...initialState,
        step: STEPS.ORDER_FINISHED,
        title: 'Estado de la Orden',
        orderCreated: createOrderResult.orderCreated,
      });
    }
    // eslint-disable-next-line
  }, [createOrderResult]);

  useEffect(() => {
    const priceProduct = productToAdd.price;
    const viewOptions = [];
    const counterOptions = [];
    const overPrice = get(productToAdd, 'options', []).reduce((addition, option) => {
      switch (option.type) {
        case 'BOOLEAN': {
          const optionsSelections = productOptions[option.id] && productOptions[option.id].optionSelected;
          if (!isEmpty(optionsSelections)) {
            const optionsSelected = filter(option?.options || [], optionSelect => {
              if (includes(optionsSelections, optionSelect._id)) {
                return true;
              }
              return false;
            });
            if (!isEmpty(optionsSelected)) {
              const objectOptionView = { name: option.name, optionsSelected: [] };
              // eslint-disable-next-line no-param-reassign
              addition += optionsSelected.reduce((additionToAdd, selectionToAdd) => {
                objectOptionView.optionsSelected.push(selectionToAdd.title);
                return additionToAdd + selectionToAdd.extraPrice;
              }, 0);
              viewOptions.push(objectOptionView);
            }
          }
          break;
        }
        case 'COUNTER': {
          const optionsCounters = get(productOptionsCount, `[${option.id}].optionCounterQuantity`, []);

          if (!isEmpty(optionsCounters)) {
            const optionsCountActive = filter(optionsCounters, optionCount => {
              return optionCount.quantity > 0;
            });
            if (!isEmpty(optionsCountActive)) {
              optionsCountActive.forEach(opt => {
                counterOptions.push({ title: opt.title, optionCounterQuantity: opt.quantity });
                // eslint-disable-next-line no-param-reassign
                addition += opt.quantity * opt.quantityExtraPrice;
              });
            }
          }
          break;
        }
        default:
          break;
      }

      return addition;
    }, 0);
    setProductToAdd({ ...productToAdd, finalPrice: overPrice + priceProduct, viewOptions, counterOptions });
    // eslint-disable-next-line
  }, [productOptions, productOptionsCount]);

  const handleOnSelectOption = (id, evt) => {
    const selectedValue = evt?.target?.value;
    const currentOption = productOptions[id] || {};
    currentOption.optionSelected = [selectedValue];

    setProductOptions({ ...productOptions, [id]: currentOption });
  };

  const handleOnClickCalculateCount = (optionId, countOptionId, operation = '') => {
    const optionCount = get(productOptionsCount, `[${optionId}]`, {});
    if (isEmpty(optionCount)) {
      return;
    }
    const index = findIndex(optionCount.optionCounterQuantity || [], { _id: countOptionId });

    if (index === -1) return;
    const currentQuantity = optionCount.optionCounterQuantity[index].quantity;
    switch (operation) {
      case '+':
        optionCount.optionCounterQuantity[index].quantity = currentQuantity + 1;
        break;
      case '-':
        if (currentQuantity > 0) optionCount.optionCounterQuantity[index].quantity = currentQuantity - 1;
        else return;
        break;

      default:
        return;
    }

    setProductOptionsCount({
      ...productOptionsCount,
      [optionId]: { ...optionCount },
    });
  };

  const handleOnClickOptionFinished = () => {
    setState({ ...state, step: STEPS.ADD_MORE_STEP, title: 'Agregar mas productos o termina la orden' });
    setOrder({ ...order, products: [...order.products, { ...productToAdd, productOptions, productOptionsCount }] });
  };

  const handleOnClickOrderFinished = () => {
    // TODO CREATE ORDER
    if (!order.customerName) message.warning('Debes capturar el nombre de la orden');
    else dispatch(sendOrder(order));
    // setState({ ...state, step: STEPS.SELECT_CATEGORY, title: 'Selecciona la categoría' });
  };
  const handleOnClickAddMore = () => {
    setState({ ...state, step: STEPS.SELECT_CATEGORY, title: 'Selecciona la categoría' });
    setProductToAdd({});
  };

  const removeItemFromOrder = idToRemove => {
    const notDeletedProducts = order.products.filter(element => element.id !== idToRemove);
    setOrder({ ...order, products: notDeletedProducts });
  };

  const onOptionRadioChange = (idOption, idOptionSelected, extraPrice = 0, isMandatory = false) => {
    const optionSelected = idOptionSelected?.target?.value;
    const option = productOptions[idOption];

    // Si no es obligatorio y se hace clic en el mismo valor ya seleccionado, deseleccionar
    const currentSelected = option?.optionSelected?.[0];
    const newSelected = !isMandatory && currentSelected === optionSelected ? [] : [optionSelected];

    setProductOptions({
      ...productOptions,
      [idOption]: { ...option, optionSelected: newSelected },
    });
  };

  const toggleOptionExpanded = optionId => {
    setExpandedOptions({
      ...expandedOptions,
      [optionId]: !expandedOptions[optionId],
    });
  };

  // const logData = useCallback(() => {
  // }, [data]);

  const initializeProductOptions = _productSelected => {
    if (_productSelected?.options?.length > 0) {
      const options = _productSelected?.options || [];
      const optionMap = options.reduce(
        (currentHashes, option) => {
          const { optionsHash, optionsCountHash } = currentHashes;

          const initialSelected = option.mandatory && option.options[0]._id;

          switch (option.type) {
            case 'BOOLEAN':
              // eslint-disable-next-line no-param-reassign
              optionsHash[option.id] = {
                optionId: option.id,
                mandatory: option.mandatory,
                optionSelected: initialSelected ? [initialSelected] : [],
                selectedExtraPrice: initialSelected ? option.options[0].extraPrice : 0,
              };
              break;
            case 'COUNTER': {
              const counterMap = get(option, 'options', []).map(optionCount => {
                return {
                  title: optionCount.title,
                  quantityExtraPrice: optionCount.extraPrice,
                  quantity: 0,
                  _id: optionCount._id,
                };
              });

              optionsCountHash[option.id] = {
                optionId: option.id,
                mandatory: option.mandatory,
                optionCounterQuantity: counterMap,
                optionCounterExtraPrice: 0,
              };
              break;
            }
            default:
              break;
          }

          return { optionsHash, optionsCountHash };
        },
        { optionsHash: {}, optionsCountHash: {} },
      );
      setProductOptions(optionMap.optionsHash);
      setProductOptionsCount(optionMap.optionsCountHash);

      // Inicializar expandedOptions: las obligatorias expandidas por defecto
      const initialExpanded = {};
      options.forEach(option => {
        initialExpanded[option.id] = option.mandatory || false;
      });
      setExpandedOptions(initialExpanded);
    }
  };

  // USE EFFECTS
  // useEffect(() => {
  //   //if (error) message.error(error);
  // }, [error]);

  // eslint-disable-next-line
  useEffect(() => {
    switch (step) {
      case STEPS.SELECT_CATEGORY:
        dispatch(fetchCategories());
        break;
      case STEPS.SELECT_PRODUCT:
        // eslint-disable-next-line
        dispatch(fetchProducts(categorySelected.id));
        break;
      case STEPS.SELECT_OPTIONS:
        initializeProductOptions(productSelected);
        break;
      // case STEPS.ADD_MORE_STEP:
      //   initializeProductOptions(productSelected);
      // break;
      default:
        break;
    }
  }, [step, dispatch, categorySelected, productSelected]);
  // END USE EFFECTS

  const renderOptionsProduct = () => {
    const { options } = productSelected;

    return options.map(option => {
      const selectOptions = option.options || [];
      const isExpanded = expandedOptions[option.id];

      const renderOptionsSelect = selectOptions.map(selection => {
        const { extraPrice, title: titleSelection, _id: id } = selection;
        return (
          <div key={id} style={{ display: 'inline-block', marginRight: '8px', marginBottom: '8px' }}>
            <Radio.Button
              key={id}
              value={id}
              onClick={selectedItem => {
                // Permitir deseleccionar si no es mandatory
                if (!option.mandatory) {
                  onOptionRadioChange(option.id, selectedItem, extraPrice, option.mandatory);
                }
              }}
              onChange={selectedItem => onOptionRadioChange(option.id, selectedItem, extraPrice, option.mandatory)}
            >
              {titleSelection}
              {extraPrice > 0 && (
                <span style={{ marginLeft: '6px', color: '#52c41a', fontWeight: 'bold' }}>+${extraPrice}</span>
              )}
            </Radio.Button>
          </div>
        );
      });

      const renderOptionsCounter = selectOptions.map((selection, idx) => {
        const optionCounter = get(productOptionsCount, `[${selection.optionId}].optionCounterQuantity`, []);

        const optionSelected = find(optionCounter, { _id: selection._id });
        const quantity = get(optionSelected, 'quantity', 0);
        return (
          <div
            key={`${selection.optionId}${idx}`}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              marginBottom: '12px',
              padding: '8px',
              border: '1px solid #f0f0f0',
              borderRadius: '4px',
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span style={{ fontWeight: '500' }}>{selection.title}</span>
              {selection.extraPrice > 0 && (
                <span style={{ fontSize: '12px', color: '#52c41a', fontWeight: 'bold' }}>
                  +${selection.extraPrice} c/u
                </span>
              )}
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <Button
                onClick={() => handleOnClickCalculateCount(selection.optionId, selection._id, '-')}
                className="btn-dec"
                type="default"
                size="small"
              >
                <FeatherIcon icon="minus" size={12} />
              </Button>
              <span style={{ minWidth: '20px', textAlign: 'center', fontWeight: 'bold' }}>{quantity}</span>
              <Button
                onClick={() => handleOnClickCalculateCount(selection.optionId, selection._id, '+')}
                className="btn-inc"
                type="default"
                size="small"
              >
                <FeatherIcon icon="plus" size={12} />
              </Button>
            </div>
          </div>
        );
      });

      let panelContent = null;
      switch (option.type) {
        case 'BOOLEAN':
        case 'OPTIONS': {
          const currentValue = productOptions[option.id]?.optionSelected?.[0] || null;
          panelContent = (
            <Radio.Group value={currentValue} onChange={evt => handleOnSelectOption(option.id, evt)} size="large">
              {renderOptionsSelect}
            </Radio.Group>
          );
          break;
        }
        case 'COUNTER':
          panelContent = renderOptionsCounter;
          break;
        default:
          return null;
      }

      const cardTitle = (
        <div
          onClick={() => toggleOptionExpanded(option.id)}
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            cursor: 'pointer',
            userSelect: 'none',
          }}
        >
          <span>{option.name}</span>
          <FeatherIcon icon={isExpanded ? 'chevron-up' : 'chevron-down'} size={18} />
        </div>
      );

      return (
        <Col sm={8} xs={24} key={option.id}>
          <Cards title={cardTitle} bodyStyle={!isExpanded ? { display: 'none' } : {}}>
            {isExpanded && panelContent}
          </Cards>
        </Col>
      );
    });
  };

  const renderStep = () => {
    switch (step) {
      // PRODUCT SELECTION
      case STEPS.SELECT_PRODUCT:
        return (
          <Row gutter={16}>
            {products.map((product, index) => (
              <Col sm={8} xs={24} key={index}>
                <Palette
                  gradient
                  direction="90deg"
                  colorCode={[theme['gray-solid'], theme['light-gray-color']]}
                  onClick={() => handleOnClickProduct(product)}
                >
                  {product.name}
                </Palette>
              </Col>
            ))}
          </Row>
        );
      // PRODUCT SELECTION
      case STEPS.SELECT_OPTIONS:
        return (
          <>
            <Row gutter={16}>{renderOptionsProduct()}</Row>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '20px' }}>
              <Button size="large" type="primary" onClick={handleOnClickOptionFinished}>
                Continuar
              </Button>
            </div>
          </>
        );

      case STEPS.ADD_MORE_STEP:
        return (
          <Cards title="Productos Seleccionados" size="large">
            <CartList
              products={order.products}
              onRemoveItem={removeItemFromOrder}
              incrementUpdate={incrementUpdate}
              decrementUpdate={decrementUpdate}
            />
            <Row
              gutter={16}
              style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around', marginBottom: '25px' }}
            >
              <Col sm={8} xs={24}>
                <span>Nombre de la orden</span>
                <Input onChange={onNameChange} placeholder="Nombre del cliente" value={order.customerName} />
              </Col>
              <Col sm={8} xs={24}>
                <span>Agregar Nota (Opcional)</span>
                <TextArea
                  onChange={onNoteChange}
                  autoSize
                  placeholder="Agrega alguna nota a la orden"
                  value={order.note}
                />
              </Col>
            </Row>
            <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', marginTop: '15px' }}>
              <Button size="large" type="primary" onClick={handleOnClickAddMore}>
                <FeatherIcon icon="plus" />
                Agregar Más
              </Button>
              <Button size="large" type="success" onClick={handleOnClickOrderFinished}>
                <FeatherIcon icon="send" />
                Terminar Orden
              </Button>
            </div>
          </Cards>
        );
      case STEPS.ORDER_FINISHED:
        return (
          <Cards
            bodyStyle={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}
            title="Orden Finalizada"
            size="large"
          >
            {createOrderResult?.error ? (
              <Result
                status="error"
                title="Resultado de la orden"
                subTitle={createOrderResult.error}
                style={{ padding: 0 }}
                extra={[]}
              />
            ) : (
              <>
                <div style={{ maxWidth: '400px', border: '2px', borderBlockColor: theme['gray-color'] }}>
                  <OrderCard
                    clients={[]}
                    ipName={ipName}
                    order={orderCreated}
                    onSuccessChangeOrder={() => console.log('changed')}
                    showActions
                  />
                </div>
              </>
            )}
            <ButtonsWrapper>
              <ButtonLineWrapper>
                <Button
                  className="btn-add_new"
                  size="default"
                  type="primary"
                  key="orders"
                  onClick={handleOnClickGoToOrders}
                >
                  <FeatherIcon icon="shopping-bag" size={14} />
                  Lista de Órdenes
                </Button>
              </ButtonLineWrapper>
              <ButtonLineWrapper>
                <Button
                  className="btn-add_new"
                  size="default"
                  type="success"
                  key="shop"
                  onClick={handleOnClickNewOrder}
                >
                  <FeatherIcon icon="shopping-cart" size={14} />
                  Crear Otra Orden
                </Button>
              </ButtonLineWrapper>
            </ButtonsWrapper>
          </Cards>
        );
      // STEPS.SELECT_CATEGORY
      default:
        return (
          <Row gutter={16}>
            {categories.map((category, index) => (
              <Col sm={8} xs={24} key={index}>
                <Palette
                  gradient
                  direction="90deg"
                  colorCode={[theme['secondary-color'], theme['primary-color']]}
                  onClick={() => handleOnClickCategory(category)}
                >
                  {category.name}
                </Palette>
              </Col>
            ))}
          </Row>
        );
    }
  };

  return (
    <>
      <PageHeader ghost title="Inicio" />
      <Main>
        <Cards title={title} size="large">
          <div className="columnCardsWrapper">{loading ? <Spin size="large" /> : renderStep()}</div>
        </Cards>
      </Main>
    </>
  );
};

export default POS;
